import DeliveryPinLocationOption from '../enums/DeliveryPinLocationOption'

export const defaultDeliveriesPreferences: IDeliveriesViewPreferences = {
  pinLocationOption: DeliveryPinLocationOption.mostPertinent,
}

export default interface IDeliveriesViewPreferences {
  pinLocationOption: DeliveryPinLocationOption
}
